import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreerRoutingModule } from './creer-routing.module';
import { StepperComponent } from './components/stepper/stepper.component';
import { ChoixFormulaireComponent } from './components/choix-formulaire/choix-formulaire.component';
import { ChoixSupportComponent } from './components/choix-support/choix-support.component';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { ValiderDemandeComponent } from './components/valider-demande/valider-demande.component';
import { ValiderElementsComponent } from './components/valider-elements/valider-elements.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormmapaInitialModule } from '../../formulaires/mapa/mapa-initial/formmapa.module';
import { FormmapaAttributionModule } from '../../formulaires/mapa/attribution/formmapa.module';
import { FormmapaAnnulationModule } from '../../formulaires/mapa/annulation/formmapa.module';
import { FormmapaRectificatifModule } from '../../formulaires/mapa/rectificatif/formmapa-rectificatif.module';
import { FormfnsModule } from '../../formulaires/fnsimple/initial/formfns.module';
import { FormfnsAnnulationModule } from '../../formulaires/fnsimple/annulation/formfns.module';
import { FormDiversInitialModule } from '../../formulaires/divers/diversInitial/formDiversInitial.module';
import { FormDiversAttributionModule } from '../../formulaires/divers/diversAttribution/formDiversAttribution.module';
import { FormfnsimpleAttribution } from '../../formulaires/fnsimple/attribution/formfns.module';
import { FormfnsimpleRectificatifModule } from '../../formulaires/fnsimple/rectificatif/formfnsimple-rectificatif.module';
import { FormStepComponent } from './components/form-step/form-step.component';
import { FormDiversCommonModule } from '../../formulaires/divers/common/formdivers.module';
import { IdAnnonceurComponent } from './components/id-annonceur/id-annonceur.component';
import { FormfnsimpleCommonModule } from '../../formulaires/fnsimple/common/formfns.module';
import { FormmapaCommonModule } from '../../formulaires/mapa/common/formmapa.module';
import { FormADModule } from '../../formulaires/adapte/formad.module';
import { FormDiversAnnulationModule } from '../../formulaires/divers/annulation/formDiversAnnulation.module';
import {EformsModule} from '../../formulaires/eforms/eforms.module';
import { FormDiversRectificatifModule } from '../../formulaires/divers/rectificatif/formDiversRectificatif.module';
import { TypeFacturationComponent } from './components/typeFacturation/type-facturation.component';
import { TypeAdresseTEMPOSTComponent } from './components/typeAdresseTEMPOST/type-adresseTEMPOST.component';
import { ClasseProfitComponent } from './components/classeProfit/classe-profit.component';
import { TypeOuiNonComponent } from './components/typeOuiNon/type-oui-non.component';
import { TypeIndexationComponent } from './components/type-indexation/type-indexation.component';
import { TypeMotsClefComponent } from './components/typeMotsClef/type-mots-clef.component';
import { TypeDeptComponent } from './components/typeDept/type-dept.component';

@NgModule({
	declarations: [
		StepperComponent,
		IntroductionComponent,
		ChoixFormulaireComponent,
		ChoixSupportComponent,
		ValiderElementsComponent,
		ValiderDemandeComponent,
		FormStepComponent,
		IdAnnonceurComponent,
		TypeFacturationComponent,
		TypeAdresseTEMPOSTComponent,
		ClasseProfitComponent,
		TypeOuiNonComponent,
		TypeIndexationComponent,
		TypeMotsClefComponent,
		TypeDeptComponent
	],
	imports: [
		CommonModule,
		CreerRoutingModule,
		ReactiveFormsModule,
		MatNativeDateModule,
		MatIconModule,
		MatTooltipModule,
		TranslateModule,
		SharedModule,
		FormsModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
		FormmapaInitialModule,
		FormmapaAttributionModule,
		FormmapaAnnulationModule,
		FormmapaRectificatifModule,
		FormfnsModule,
		FormfnsAnnulationModule,
		FormDiversInitialModule,
		FormDiversAnnulationModule,
		FormDiversRectificatifModule,
		FormfnsimpleAttribution,
		FormfnsimpleRectificatifModule,
		FormDiversAttributionModule,
		FormDiversCommonModule,
		FormfnsimpleCommonModule,
		FormmapaCommonModule,
		FormADModule,
		EformsModule
	],
	exports: [FormStepComponent, ChoixSupportComponent, TypeIndexationComponent],
})
export class CreerModule { }
